const Fundo = () => {
  return (
    <div class="] w-full h-full fixed bg-center bg-cover">
      <div class="bg-gradient-to-br from-[#f2f1ed] via-[#f2f1ed] to-[#f2f1ed] min-h-screen"></div>

    </div>
  );
};
export default Fundo;
